if(!customElements.get('component-carousel')) {
  class ComponentCarousel extends HTMLElement {
    constructor() {
      super();
      this.sliderElement = this.querySelector('.keen-slider');
      this.slides = this.querySelectorAll('.keen-slider-slide');
      this.pageInfo = this.querySelector('.keen-slider-page');

      this.carouselMode = this.dataset.carouselMode;
      this.carouselAutoplay = this.dataset.carouselAutoplay;
      this.carouselAutomove = parseFloat(this.dataset.carouselAutomove);
      this.carouselLoop = this.dataset.carouselLoop;
      this.carouselCenteredDesktop = this.dataset.carouselCenteredDesktop;
      this.carouselCenteredMobile = this.dataset.carouselCenteredMobile;
      this.carouselSpacingDesktop = this.dataset.carouselSpacingDesktop;
      this.carouselSpacingTablet = this.dataset.carouselSpacingTablet;
      this.carouselSpacingMobile = this.dataset.carouselSpacingMobile;
      this.slidesPerViewDesktop = this.dataset.slidesPerViewDesktop;
      this.slidesPerViewTablet = this.dataset.slidesPerViewTablet;
      this.slidesPerViewMobile = this.dataset.slidesPerViewMobile;

      this.currentSlide;

      if (this.dataset.initOndemand!='true') {
        setTimeout(()=>{ //The timeout is for the customizer
          this.initSlider();
        }, 1);
      }

    }
    
    initSlider() {
      if(this.slides.length > 0 && !this.initialized) {
        this.initialized = true;
        var config = {
          mode: this.carouselMode,
          prevButton: this.querySelector('.keen-arrow.prev:not(.keen-slider-slide .keen-arrow.prev)'),
          nextButton: this.querySelector('.keen-arrow.next:not(.keen-slider-slide .keen-arrow.next)'),
          autoplay: this.carouselAutoplay,
          automove: this.carouselAutomove,
          slideChanged: (e)=>{         
            if(this.currentSlide)
              this.currentSlide.classList.remove('current');
            this.currentSlide = e.currentSlide();
            if(this.currentSlide)
              this.currentSlide.classList.add('current');
          },
          pauseOnHover: true,
          pageInfo: this.pageInfo,
          loop: this.carouselLoop=="true",
          breakpoints: {
            '(min-width: 901px)': {
              centered: this.carouselCenteredDesktop=="true",
              spacing: parseInt(this.carouselSpacingDesktop),
              slidesPerView: this.slidesPerViewDesktop
            },
            '(min-width: 601px) and (max-width: 900px)': {
              centered: this.carouselCenteredMobile=="true",
              spacing: parseInt(this.carouselSpacingTablet),
              slidesPerView: this.slidesPerViewTablet
            },
            '(max-width: 600px)': {
              centered: this.carouselCenteredMobile=="true",
              spacing: parseInt(this.carouselSpacingMobile),
              slidesPerView: this.slidesPerViewMobile
            }
          }
        }

        var dots = this.querySelector('.keen-dots:not(.keen-slider-slide .keen-dots)');
        if (dots) {
          config = {...config, dots: dots};
        } else {
          var bar = this.querySelector('.keen-nav-bar:not(.keen-slider-slide .keen-nav-bar)');
          config = {...config, navBar: bar, rubberband: false};
        }
        this.sliderObj = new KeenSlider(this.sliderElement, config);
  
        var matchHeightSelectors = this.dataset.matchHeightSelectors;
        if (matchHeightSelectors) {
          var layoutTId = 0;
          var slider = this.sliderElement;
          function layout() {
            clearTimeout(layoutTId);
            layoutTId = setTimeout(function() {
              var selectors = matchHeightSelectors.split(',');
              selectors.forEach(selector=> {
                $s.matchHeight(slider.querySelectorAll(selector));
              });
            }, 10);
          }
          $s.resizeWidthHandle(layout);
        }

        if(Shopify.designMode) {
          this.addEventListener('shopify:block:select', (e)=>{
            let index = Array.from(this.slides).findIndex(x=>x==e.target);
            if(index>=0) {
              setTimeout(()=>{
                this.sliderObj.moveToSlideRelative(index, true, 0)
              }, 10);
            }
          });
        }
      }
    }
  }
  customElements.define('component-carousel', ComponentCarousel);
}

if(!customElements.get('component-card')) {
  class ComponentCard extends HTMLElement {
    constructor() {
      super();
      this.sliderElement = this.querySelector('.keen-slider');
      this.slides = this.querySelectorAll('.image-slider-slide');

      this.carouselMode = this.dataset.carouselMode;
      this.carouselAutoplay = this.dataset.carouselAutoplay;
      this.carouselAutomove = parseFloat(this.dataset.carouselAutomove);
      this.carouselLoop = this.dataset.carouselLoop;
      this.carouselCenteredDesktop = this.dataset.carouselCenteredDesktop;
      this.carouselCenteredMobile = this.dataset.carouselCenteredMobile;
      this.carouselSpacingDesktop = this.dataset.carouselSpacingDesktop;
      this.carouselSpacingTablet = this.dataset.carouselSpacingTablet;
      this.carouselSpacingMobile = this.dataset.carouselSpacingMobile;
      this.slidesPerViewDesktop = this.dataset.slidesPerViewDesktop;
      this.slidesPerViewTablet = this.dataset.slidesPerViewTablet;
      this.slidesPerViewMobile = this.dataset.slidesPerViewMobile;

      if (this.dataset.initOndemand!='true') {
        setTimeout(()=>{ //The timeout is for the customizer
          this.initSlider();
        }, 1);
      }

    }
    
    initSlider() {
      if(this.slides.length > 0 && !this.initialized) {
        this.initialized = true;
        var config = {
          slides: '.image-slider-slide',
          mode: this.carouselMode,
          prevButton: this.querySelector('.keen-arrow.prev'),
          nextButton: this.querySelector('.keen-arrow.next'),
          autoplay: this.carouselAutoplay,
          automove: this.carouselAutomove,
          pauseOnHover: true,
          loop: this.carouselLoop=="true",
          breakpoints: {
            '(min-width: 901px)': {
              centered: this.carouselCenteredDesktop=="true",
              spacing: this.carouselSpacingDesktop,
              slidesPerView: this.slidesPerViewDesktop
            },
            '(min-width: 601px) and (max-width: 900px)': {
              centered: this.carouselCenteredMobile=="true",
              spacing: this.carouselSpacingTablet,
              slidesPerView: this.slidesPerViewTablet
            },
            '(max-width: 600px)': {
              centered: this.carouselCenteredMobile=="true",
              spacing: this.carouselSpacingMobile,
              slidesPerView: this.slidesPerViewMobile
            }
          }
        }
        var dots = this.querySelector('.keen-dots:not(.keen-slider-slide .keen-dots)');
        if (dots) {
          config = {...config, dots: dots};
        } else {
          var bar = this.querySelector('.keen-nav-bar:not(.keen-slider-slide .keen-nav-bar)');
          config = {...config, navBar: bar, rubberband: false};
        }
        this.sliderObj = new KeenSlider(this.sliderElement, config);

        if(Shopify.designMode) {
          this.addEventListener('shopify:block:select', (e)=>{
            let index = Array.from(this.slides).findIndex(x=>x==e.target);
            if(index>=0) {
              setTimeout(()=>{
                this.sliderObj.moveToSlideRelative(index, true, 0)
              }, 10);
            }
          });
        }
      }
    }
  }
  customElements.define('component-card', ComponentCard);
}
